import { CourseProvider } from './CourseContext';
import CoursesModeDetailsHeader from './CoursesModeDetailsHeader';
import CoursesModeDetailsCourseInfo from './CoursesModeDetailsCourseInfo';
import CoursesModeDetailsFooter from './CoursesModeDetailsFooter';

export default function CoursesModeDetails({ course, onClose, onSave }) {
    return (
        <CourseProvider initialCourse={course}>
            <div className="mode-details">
                <CoursesModeDetailsHeader onClose={onClose} />
                <CoursesModeDetailsCourseInfo />
                <CoursesModeDetailsFooter onSave={onSave} onClose={onClose} />
            </div>
        </CourseProvider>
    );
}
